// extracted by mini-css-extract-plugin
export default {"prBreadcrumbArea":"Breadcrumb_prBreadcrumbArea__Ojgf5","breadcrumbTitle":"Breadcrumb_breadcrumbTitle__Snaxi","breadcrumb--2":"Breadcrumb_breadcrumb--2__yake3"};